import React from 'react';
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Button
} from 'shards-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimes, faInfoCircle } from '@fortawesome/free-solid-svg-icons';

const CheckinFeatureModal = ({ isOpen, toggle, onEnable, infoMode = false }) => {
  return (
    <Modal size="md" open={isOpen} toggle={toggle} className="checkin-feature-modal">
      <style>
        {`
          .checkin-feature-modal .modal-content {
            border-radius: 6px;
            border: none;
            box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
          }
          
          .checkin-feature-modal .modal-header {
            background-color: #fff;
            border-bottom: 1px solid #eaedf3;
            padding: 16px 20px;
          }
          
          .checkin-feature-modal .modal-title {
            font-weight: 600;
            color: #3D5170;
            display: flex;
            align-items: center;
          }
          
          .feature-icon {
            color: #21AA73;
            margin-right: 12px;
            font-size: 20px;
          }
          
          .modal-description {
            color: #495057;
            font-size: 15px;
            line-height: 1.6;
            margin-bottom: 20px;
          }
          
          .benefits-list {
            list-style: none;
            padding: 0;
            margin: 0;
          }
          
          .benefit-item {
            display: flex;
            align-items: flex-start;
            margin-bottom: 12px;
            color: #495057;
            font-size: 14px;
          }
          
          .benefit-item .icon {
            color: #21AA73;
            margin-right: 12px;
            margin-top: 3px;
          }
          
          .benefit-item:last-child {
            margin-bottom: 0;
          }

          .info-note {
            margin-top: 20px;
            padding: 12px 16px;
            background-color: #F8F9FA;
            border-left: 4px solid #21AA73;
            border-radius: 4px;
            font-size: 13px;
            color: #495057;
            line-height: 1.5;
          }

          .info-icon {
            color: #21AA73;
            margin-right: 8px;
          }
        `}
      </style>
      
      <ModalHeader toggle={toggle}>
        <FontAwesomeIcon icon={faCheckCircle} className="feature-icon" />
        {infoMode ? "Check-in Feature Information" : "Check-in Feature"}
      </ModalHeader>
      
      <ModalBody>
        <div className="modal-description">
          Enable the check-in feature to allow users to record their presence at authorized locations. This helps maintain accountability and track attendance effectively.
        </div>
        
        <div className="benefits-list">
          <div className="benefit-item">
            <FontAwesomeIcon icon={faCheckCircle} className="icon" />
            <div>Track user attendance at authorized locations in real-time</div>
          </div>
          <div className="benefit-item">
            <FontAwesomeIcon icon={faCheckCircle} className="icon" />
            <div>Verify user presence with GPS location data</div>
          </div>
          <div className="benefit-item">
            <FontAwesomeIcon icon={faCheckCircle} className="icon" />
            <div>Generate detailed reports of check-in history</div>
          </div>
          <div className="benefit-item">
            <FontAwesomeIcon icon={faCheckCircle} className="icon" />
            <div>Ensure compliance with attendance requirements</div>
          </div>
        </div>

        <div className="info-note">
          <FontAwesomeIcon icon={faInfoCircle} className="info-icon" />
          <strong>Important Note:</strong> While officers can sign in to locations to issue citations without being physically present, regular check-ins require users to be within 100 meters of the location. This ensures accurate attendance tracking while maintaining flexibility for enforcement activities.
        </div>
      </ModalBody>
      
      {!infoMode && (
        <ModalFooter>
          <Button theme="light" onClick={toggle}>
            <FontAwesomeIcon icon={faTimes} className="mr-1" />
            Cancel
          </Button>
          <Button theme="accent" onClick={onEnable}>
            <FontAwesomeIcon icon={faCheckCircle} className="mr-1" />
            Enable Check-ins
          </Button>
        </ModalFooter>
      )}
    </Modal>
  );
};

export default CheckinFeatureModal; 